/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Near_Me_HintInputs */

const en_directory_search_near_me_hint = /** @type {(inputs: Directory_Search_Near_Me_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses your location this once`)
};

const pl_directory_search_near_me_hint = /** @type {(inputs: Directory_Search_Near_Me_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Użyje Twojej lokalizacji, tylko teraz`)
};

/**
* | output |
* | --- |
* | "Uses your location this once" |
*
* @param {Directory_Search_Near_Me_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_near_me_hint = /** @type {((inputs?: Directory_Search_Near_Me_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Near_Me_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_near_me_hint(inputs)
	return en_directory_search_near_me_hint(inputs)
});